function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.25 18.9575C14.5664 18.8788 13.9184 18.6915 13.3259 18.4H8.75V21.25C8.75 21.6642 8.41421 22 8 22C7.58579 22 7.25 21.6642 7.25 21.25V18.4H2L8 4L10.2954 9.50885C11.0801 5.75919 13.3398 2 16 2C19.31 2 22 7.82 22 12.2C22 16.2439 19.7069 18.6171 16.75 18.9575V21.25C16.75 21.6642 16.4142 22 16 22C15.5858 22 15.25 21.6642 15.25 21.25V18.9575ZM16 4C17.62 4 20 8.32 20 12.2C20 14.7405 18.873 16.4559 16.9919 16.8912L18.672 12.8691C18.8317 12.4869 18.6513 12.0476 18.2691 11.888C17.8869 11.7283 17.4476 11.9087 17.288 12.2909L16.75 13.5787V8C16.75 7.58579 16.4142 7.25 16 7.25C15.5858 7.25 15.25 7.58579 15.25 8V11.5233L14.9322 10.7613C14.7728 10.379 14.3336 10.1983 13.9513 10.3578C13.569 10.5172 13.3883 10.9564 13.5478 11.3387L15.25 15.4201V16.9394C13.2241 16.5991 12 14.8476 12 12.2C12 8.32 14.38 4 16 4ZM8.75 16.4V14.5C8.75 14.0858 8.41421 13.75 8 13.75C7.58579 13.75 7.25 14.0858 7.25 14.5V16.4H5L8 9.2L11 16.4H8.75Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=Trees.js.map